import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useThemeContext } from '../../../../hook/useThemeManager';
import { theme } from '../../../../constants/theme';
import { FONT_ENUM } from '../../../../types/global/fonts.types';
import { Campaign } from '@mui/icons-material';

export const ContestPromotionsTab: React.FC = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: '1.25rem',
                    color: theme[themeStyle].primary_white,
                    mb: 3,
                }}>
                Event Promotions
            </Typography>

            <Card
                sx={{
                    backgroundColor: theme[themeStyle].secondaryBg,
                    borderRadius: 2,
                    textAlign: 'center',
                    py: 6,
                }}>
                <CardContent>
                    <Campaign sx={{ fontSize: 64, color: theme[themeStyle].primary_white, mb: 2 }} />
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            fontSize: '1.5rem',
                            color: theme[themeStyle].primary_white,
                            mb: 1,
                        }}>
                        Promotions Coming Soon
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            fontSize: '1rem',
                            color: theme[themeStyle].light_gray_text,
                            maxWidth: 500,
                            mx: 'auto',
                        }}>
                        We're developing new promotional tools to help you spread the word about your campaign. Soon
                        you'll be able to create marketing campaigns, generate shareable content, and track promotion
                        performance.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};
